module.exports = __webpack_public_path__ + "static/media/Note-Click-Bloom-Textures-Click_Boom_00049.b1801c38.png";